// tslint:disable: no-eval
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { CallApiMethodsService } from 'src/app/services/AsynchronousRequestServices/call-api-methods.service';
import { UserInformationService } from 'src/app/services/TemplateServices/user-information.service';

import { ArrayMultisortPipe } from 'src/app/pipes/array-multisort.pipe';

import { RegisteredEntities } from 'src/app/interfaces/entities';
import { StringValues } from 'src/app/interfaces/undetermined';
import { User, Menu, Modules } from 'src/app/interfaces/user';

@Component({
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    providers: [ArrayMultisortPipe],
    selector: 'app-index',
})
export class IndexComponent implements OnInit, OnDestroy {
    // title: Título
    @Input() title: string;
    // information: Descripción
    @Input() information: string;
    // error: Innformación de errores
    @Input() error: string;
    // status: Innformación de estado de petición
    @Input() status: string;

    // selectedEntity: Entidad seleccionada
    selectedEntity: string;

    // homePermits: Acceo a botones individuales
    homePermits: Modules[];
    // reportPermits: Acceso Reportes
    reportPermits: Modules[];
    // markerPermits: Acceso a Marcadores
    markerPermits: Modules[];

    constructor(
        private callApiMethods: CallApiMethodsService,
        private arrayMultisort: ArrayMultisortPipe,
        public user: UserInformationService,
        private router: Router,
    ) {
        // ↓↓ Asigna los títulos
        this.information = !this.information ? "Generamos información estratégica que permite tomar decisiones acertadas en tiempo real." : null;
        this.title = !this.title ? "Bienvenido a GC Balanced!!" : null;
    }

    ngOnInit() {
        // ↓^6 Asigna los módulos con acceso para los botones
        this.homePermits = this.user.modules.filter((elm: Modules) => elm.parent === "0" && elm.id !== "59");
        this.homePermits = this.arrayMultisort.transform(this.homePermits, [{ key: "order", type: "number" }]);
        this.reportPermits = this.user.modules.filter((elm: Modules) => elm.parent === "-2");
        this.reportPermits = this.arrayMultisort.transform(this.reportPermits, [{ key: "order", type: "number" }]);
        this.markerPermits = this.user.modules.filter((elm: Modules) => elm.marker);
        this.markerPermits = this.arrayMultisort.transform(this.markerPermits, [{ key: "marker", type: "number" }]);
        // ↓ Destruye las instancias de materializecss
        this.destroyInstances();
        // ↓ Inicia las configuraciones de materializecss
        setTimeout(() => { this.setMaterialize(); }, 0);
    }

    // openTapTarget(): Método que abre el tap target de materialize
    openTapTarget() {
        const instanceTapTarget = M.TapTarget.getInstance(document.querySelector('.tap-target'));
        instanceTapTarget ? instanceTapTarget.open() : M.TapTarget.init(document.querySelector('.tap-target'), {}).open();
    }

    // getEntities(): Método que carga las entidades que tienen acceso a Balanced
    getEntities() {
        // ↓ Verifica que las entidades aún no se hayan cargado
        if (!this.user.entitiesList) {
            // ↓ Asigna las entidades al servicio de usuarios para que perduren aún si se cambia de página
            this.callApiMethods.sendAsynchronousRequest("management", "getEntities", { operation: 1 })
                .then((data: RegisteredEntities[]) => this.user.entitiesList = data)
                .catch(this.callApiMethods.setError);
        }
    }

    /* setEntity(): Método que obtiene el id de la entidad seleccionada
        data: Listado de entidades (Valor que devuelve el componente de select2)
        Formato: → Nombre Entidad (Id Entidad)
    */
    setEntity(data: string[]) {
        // ↓ Asigna solo el id
        this.selectedEntity = data.length > 0 ? data[0].split('(')[data[0].split('(').length - 1].slice(0, -1) : null;
    }

    // showEntity(): Método que trae la información de la entidad seleccionada
    showEntity() {
        // ↓ Verifica que se haya seleccionado una entidad
        if (this.selectedEntity) {
            this.callApiMethods.sendAsynchronousRequest("management", "getEntities",
                { operation: 2, entity: this.selectedEntity }).then((data: User) => {
                    // ↓ Asigna la información al sevicio de usuarios
                    [this.user.entityId, this.user.entityName, this.user.entityAgreement] = [data.sess_entd, data.sess_nomEnt, data.sess_conv];
                    // ↓ Genera el menú de la entidad
                    this.setEntityMenu();
                }).catch(this.callApiMethods.setError);
        }
    }

    // setEntityMenu(): Método que genera el menú de la entidad
    setEntityMenu() {
        // ↓ Verifica si se había seleccionado una entidad antes
        if (this.user.userMenu.Dashboard) {
            // ↓↓↓ Elimina la información de la entidad anterior
            delete this.user.userMenu.Dashboard;
            window.localStorage.removeItem("dashboard");
            window.localStorage.removeItem("entity");
        }
        this.callApiMethods.sendAsynchronousRequest("users", "getEntityMenu").then((data: StringValues) => {
            // ↓↓ Agrega la información de la entidad al storage
            localStorage.setItem("dashboard", JSON.stringify({ ...data, time: new Date().getTime() }));
            localStorage.setItem("entity", JSON.stringify({ [this.user.userToken]: [this.user.entityId, this.user.entityName, this.user.entityAgreement], time: new Date().getTime() }));
            // ↓ Modifica el menú del usuario añadiendo el menú de la entidad
            this.user.userMenu = { ...this.user.userMenu, ...this.dMenu(data[this.user.userToken]) };
            // ↓ Comparte los cambios
            this.user.emitter.next(true);
            // ↓ Redirige a la página principal de las entidades
            this.router.navigate(["Entities/Home"]);
        }).catch(this.callApiMethods.setError);
    }

    // dMenu(): Método que formatea el menú
    dMenu(value: string): Menu {
        const dec: any = eval("UTF8ArrToStr")(eval("base64DecToArr")(value));
        const arr: {} = dec.split("gkhcdkh42fdsdf67kjhkjVDFHDS65ksd");
        const txt: any = eval("UTF8ArrToStr")(eval("base64DecToArr")(arr[1]));
        return JSON.parse(txt);
    }

    // setMaterialize(): Método que inicia la configuración materializecss
    setMaterialize = () => {
        const floatingButton: NodeListOf<HTMLElement> = document.querySelectorAll('.fixed-action-btn');
        const dropdown: NodeListOf<HTMLElement> = document.querySelectorAll('.dropdown-index');
        const tapTarget: NodeListOf<HTMLElement> = document.querySelectorAll('.tap-target');
        const modal: NodeListOf<HTMLElement> = document.querySelectorAll('.modal-index');
        // ↓ Verifica que los desplegables hayan cargado
        if (dropdown.length > 0) {
            M.Modal.init(modal, { inDuration: 400, outDuration: 500 });
            M.Dropdown.init(dropdown, { coverTrigger: true });
            M.FloatingActionButton.init(floatingButton, {});
            M.TapTarget.init(tapTarget, {});
        } else { setTimeout(() => { this.setMaterialize(); }, 100); }
        // ↑ Si los desplegables no han cargado reinicia el método
    }

    // destroyInstances(): Método que destruye las instancias de materializecss
    destroyInstances() {
        // ↓* Destruye las instancias de materializecss
        const floatingButton: NodeListOf<HTMLElement> = document.querySelectorAll('.fixed-action-btn');
        const dropdown: NodeListOf<HTMLElement> = document.querySelectorAll('.dropdown-index');
        const tapTarget: NodeListOf<HTMLElement> = document.querySelectorAll('.tap-target');
        const modal: NodeListOf<HTMLElement> = document.querySelectorAll('.modal-index');
        floatingButton.forEach((elm: HTMLElement) => M.FloatingActionButton.getInstance(elm) ? M.FloatingActionButton.getInstance(elm).destroy() : null);
        tapTarget.forEach((elm: HTMLElement) => M.TapTarget.getInstance(elm) ? M.TapTarget.getInstance(elm).destroy() : null);
        dropdown.forEach((elm: HTMLElement) => M.Dropdown.getInstance(elm) ? M.Dropdown.getInstance(elm).destroy() : null);
        modal.forEach((elm: HTMLElement) => M.Modal.getInstance(elm) ? M.Modal.getInstance(elm).destroy() : null);
    }

    ngOnDestroy() { this.destroyInstances(); }
    // ↑ Destruye las instancias de materializecss
}
